<template>
    <div v-if="success" class="mt-2 mb-4">
        Vaša žiadosť o {{request.isSale ? 'predaj' : 'nákup'}} cenných papierov bola odoslaná na spracovanie.<br>
        O jej výsledku Vás budeme informovať.
    </div>
    <form v-else class="request-wrapper" ref="tradeForm" @submit.prevent="addNewTradeRequest()">
        <div class="row">
            <div class="col-12 col-md-5">
                <div class="row">
                    <b-form-group>
                        <b-form-radio-group
                            v-model="request.isSale"
                            :options="options"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            name="radio-btn-outline"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="row">
                    <div class="col-4">Aktívum:</div>
                    <select class="col-8 form-control"
                            v-model="request.asset"
                            @change="setAsset($event)"
                            :required="!disabled"
                            :disabled="disabled">
                        <option value=""></option>
                        <option v-for="asset in assets" v-bind:value="asset.asset">{{asset.asset}}</option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-4">ISIN:</div>
                    <input class="col-8 form-control" type='text' :disabled="disabled"
                        v-model="request.isin" :required="!disabled"
                    />
                </div>
                <div class="row">
                    <div class="col-4">Počet:</div>
                    <input class="col-8 form-control" type='number'
                        v-model="request.volume" :required="!disabled"
                    />
                </div>
                <div class="row">
                    <div class="col-4">Portfólio:</div>
                    <select class="col-8 form-control" v-model="request.portfolio" :required="!disabled">
                        <option value=""></option>
                        <option v-for="portfolio in portfolios" v-bind:value="portfolio.portfolio">{{portfolio.portfolio}}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-6 ml-md-4">
                <div class="row">
                    <div class="col-3 col-md-4">Cena:</div>
                    <div class="col-5 col-md-4">
                        <input type="radio" name="price" value="market" v-model="request.priceType">
                        <label>Trhová</label><br>
                        <input type="radio" name="price" value="limit" v-model="request.priceType">
                        <label>Limitná</label><br>
                    </div>
                    <input class="col-4 col-md-4 form-control" type='number'
                        v-model="request.price"
                        :disabled="request.priceType === 'market'"
                        :required="request.priceType !== 'market' && !disabled"
                    />
                </div>
                <div class="row">
                    <div class="col-4">Poznámka:</div>
                    <textarea class="col-8 form-control" 
                        v-model="request.message"
                    />
                </div>
                <div class="row">
                    <input class="form-control col-5 col-md-5 pin-input" type='text'
                        v-model="verification.code" placeholder="Zadajte SMS kód" required
                    />
                    <button class="btn btn-dark btn-sm offset-1 col-6 col-md-6" @click="sendPin()">Zaslať SMS kód</button>
                </div>
                <div class="row float-right">
                    <button type="submit" class="btn btn-primary btn-sm w-20">Odoslať</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "TradeForm",
        created() {
            if (this.requestInfo.code) {
                const asset = this.getAssetByCode(this.requestInfo.code);
                this.request.asset = asset.asset;
                this.request.isin = asset.isin;
            }

            if (this.requestInfo.message) {
                this.request.message = this.requestInfo.message;
                this.disabled = this.requestInfo.disabled;
            }
        },
        computed: {
            assets() {
                return this.$store.state.assets.list;
            },
            portfolios() {
                return this.$store.state.portfolio.items;
            }
        },
        methods: {
            addNewTradeRequest() {
                this.$store.dispatch('account/activate', this.verification).then(() => {
                    this.$store.dispatch('account/newTradeRequest', this.request).then((response) => {
                        this.success = true;
                    });
                });
            },
            setAsset(event) {
                const result = this.assets.filter(asset => {
                    return asset.asset === event.target.value;
                })
                this.request.isin = result[0] ? result[0].isin : '';
            },
            sendPin() {
                this.$store.dispatch('account/sendPinCodeAgain')
            },
            getAssetByCode(code) {
                const result = this.assets.filter(asset => {
                    return asset.code === code;
                })
                return result[0];
            }
        },
        data() {
            return {
                request: {
                    isSale: this.requestInfo.isSale,
                    asset: null,
                    isin: null,
                    volume: null,
                    portfolio: null,
                    priceType: 'market',
                    price: null,
                    message: null },
                verification: {
                    code: '',
                    remember: true,
                },
                options: [
                    { text: 'NÁKUP', value: false },
                    { text: 'PREDAJ', value: true}
                ],
                success: false,
                disabled: false
            }
        },
        props: {
            requestInfo: {
                type: Object,
                default: function () {
                    return {
                        isSale: true,
                        code: ''
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/styles/variables.scss";
    .request-wrapper {
		font-size: 13px;

		> div .row {
			margin-top: 15px;

			> div:first-child {
				color: #9a9a9a;
			}
		}

        input[type="radio"] {
            margin-right: 10px;
        }

        select {
            cursor: pointer;
        }
    }

    .pin-input {
        font-size: 12px;
        text-align: center;
    }

    @include media-breakpoint-down(md) {
        .modal {
            padding-left: 2.5vw !important;

            .modal-dialog {
                margin-left: 0px !important;
            }
        }
        .modal-content {
            width: 95vw;
            padding-left: 15px !important;
            padding-right: 15px !important;
        }

        .pin-input {
            font-size: 10.5px;
            height: 32px
        }
    }
</style>